import { Grid, Stack, Typography } from '@mui/material';
import { Box, Container, styled } from '@mui/system';
import { colors, fontSize, fontWeight } from '../../constants';

const LabelTypography = styled(Typography)({
  fontSize: '0.8rem',
  color: colors.grayBody
});

const StyledContainer = styled(Container)({
  width: '100%',
  paddingLeft: '0.5rem',
  paddingRight: '1rem'
});

const CountBox = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between'
});

const CountTypography = styled(Typography)({
  fontSize: '1.2rem',
  fontWeight: fontWeight.bold
});

const CountLabel = styled(LabelTypography)({
  paddingTop: '0.4rem'
});

const InfoBox = styled(Box)({
  gridRow: 3,
  gridColumn: 1,
  display: 'grid',
  gridTemplateColumns: '1rem 1rem',
  gap: '0.3rem',
  flexDirection: 'row',
  fontSize: '0.6rem',
  paddingTop: '0.5rem',
  borderTop: `0.06rem solid ${colors.blueBorderLight}`
});

const InfoIcon = styled(Box)({
  gridColumn: 1,
  alignSelf: 'center'
});

const InfoLabel = styled(Typography)({
  gridColumn: 2,
  alignSelf: 'center',
  whiteSpace: 'nowrap'
});

const ChartsContainer = styled(Grid)({
  paddingTop: '2rem',
  paddingBottom: '1rem',
  '& ul': {
    margin: 0,
    listStyle: 'none',
    padding: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    rowGap: 10,
    paddingRight: 30,
    '& li': {
      display: 'flex',
      alignItems: 'center',
      fontSize: 12,
      '& span': {
        width: 8,
        height: 8,
        borderRadius: '50%',
        marginRight: 10,
        marginLeft: 10,
        '&.completed': {
          background: colors.info
        },
        '&.approved': {
          background: colors.iconSearch
        },
        '&.pending': {
          background: colors.purpleLight
        },
        '&.rejected': {
          background: colors.pinkDark
        }
      }
    }
  }
});

const GraphContainerStyle = styled(Box)(() => ({
  border: `1px solid ${colors.graphContainerBorder}`,
  borderRadius: 4,
  padding: '10px',
  height: '100%',
  boxSizing: 'border-box',
  '& .heading-block': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '0 10px 10px',

    '& h4': {
      fontSize: 18,
      margin: 0,
      fontWeight: 500,
      color: colors.black,
      '& span': {
        paddingLeft: 10,
        fontSize: 18,
        fontWeight: 500
      }
    }
  },
  '& .chart-container': {},
  '&.totalActiveUserGraph': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '& > div+div': {
      width: '12rem !important',
      '& canvas': {
        height: '100% !important',
        width: '100% !important'
      }
    }
  }
}));
const ImageLoopContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  '& .plusIcon': {
    width: 24,
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    backgroundColor: colors.iconSearch,
    marginLeft: -8,
    cursor: 'pointer'
  },
  '& img': {
    width: 24,
    height: 24,
    borderRadius: '50%',
    marginLeft: -8,
    border: `2px solid ${colors.greyDisabled}`,
    boxSizing: 'border-box',
    '&:first-child': {
      marginLeft: 0
    }
  }
});

const SearchStyle = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '0.5rem',
  flexWrap: 'nowrap',
  '& .input-Base-style': {
    flex: 1,
    minWidth: 0,
    '& .MuiInputBase-root': {
      background: colors.blueChipBg,
      width: '100%',
      minWidth: 0,
      borderRadius: 6,
      border: `1px solid ${colors.greyDisabled}`
    },
    '& .MuiOutlinedInput-input': {
      fontSize: fontSize.small
    }
  }
}));

export {
  InfoBox,
  ChartsContainer,
  CountBox,
  CountLabel,
  CountTypography,
  InfoIcon,
  GraphContainerStyle,
  InfoLabel,
  StyledContainer,
  ImageLoopContainer,
  SearchStyle
};
